
import CaktoApiDocHeader from '@/sections/@dashboard/cakto-api/components/CaktoApiDocHeader';
import CaktoApiMcpCard from '@/sections/@dashboard/cakto-api/components/CaktoApiMcpCard';
import CaktoApiTable from '@/sections/@dashboard/cakto-api/components/CaktoApiTable';
import {
    Container,
    Stack
} from '@mui/material';
import { PageTitle } from '../../utils/pageTitle';

export default function CaktoAPI() {

    return (
        <>
            <PageTitle area="Dashboard" screen="Cakto API" />

            <Container maxWidth="xl">
                <Stack gap={3}>
                    <CaktoApiDocHeader />
                    <CaktoApiMcpCard />
                    <CaktoApiTable />
                </Stack>
            </Container>
        </>
    );
}